import React from 'react';

export const Loader = (props) => {
    return (
        <div className={"ajax-progress " + props.class}>
        </div>
    )
}